import {ICell, ICellMetricAggregator} from "./PA.HyperRectangle.IF";
import * as _ from 'lodash'

export class AdditiveMetricAggr
    implements ICellMetricAggregator
{
    private _metricId: string
    private _sum: number

    constructor(metricId: string) {
        this._metricId = metricId
        this._sum = 0
    }

    add(cell: ICell, scaleFactor: number): void {
        let incrValue = cell.getCellMetricValue(this._metricId)
        if (_.isNumber(scaleFactor))
            this._sum += _.toNumber(incrValue) * scaleFactor
        else
            this._sum += _.toNumber(incrValue)
    }

    getResults(): string | number {
        return this._sum;
    }

}